const collectionId = 'equality';
const milleage = 'Égalité';

module.exports = [
  {
    id: 'silver-30',
    label: 'Monnaie de <b>30 euros Argent</b>',
    value: 30,
    sellPrice: 30,
    state: 2,
    price: '30,00 €',
    collection: collectionId,
    wave: 2,
    launchDate: '2026-03-10',
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Argent 900‰' },
      { label: 'Poids', value: '16 g' },
      { label: 'Diamètre', value: 'Ø 33' },
      { label: 'Exemplaires', value: '75 000' },
    ],
  },
  {
    id: 'silver-100',
    label: 'Monnaie de <b>100 euros Argent</b>',
    value: 100,
    sellPrice: 100,
    state: 3,
    price: '100,00 €',
    collection: collectionId,
    wave: 1,
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Argent 900‰' },
      { label: 'Qualité', value: 'Brillant Universel' },
      { label: 'Poids', value: '45 g' },
      { label: 'Diamètre', value: 'Ø 47' },
      { label: 'Exemplaires', value: '10 000' },
    ],
  },
  {
    id: 'gold-250',
    label: 'Monnaie de <b>250 euros Or</b>',
    value: 250,
    sellPrice: 250,
    state: 0,
    price: '250,00 €',
    collection: collectionId,
    wave: 1,
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Or 999‰' },
      { label: 'Qualité', value: 'Brillant Universel' },
      { label: 'Poids', value: '1,75 g' },
      { label: 'Diamètre', value: 'Ø 13' },
      { label: 'Exemplaires', value: '15 000' },
    ],
  },
  {
    id: 'gold-1000',
    label: 'Monnaie de <b>1 000 euros Or</b>',
    value: 1000,
    sellPrice: 1090,
    state: 3,
    price: '1000,00 €',
    collection: collectionId,
    wave: 2,
    subscription: {
      startDate: '2026-03-10',
      endDate: '2026-04-10',
    },
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Or 999‰' },
      { label: 'Qualité', value: 'Brillant Universel' },
      { label: 'Poids', value: '6,5 g' },
      { label: 'Diamètre', value: 'Ø 23' },
      { label: 'Exemplaires', value: '6 000' },
    ],
  },
  {
    id: 'gold-2500',
    label: 'Monnaie de <b>2 500 euros Or</b>',
    value: 2500,
    sellPrice: 2675,
    state: 3,
    price: '2500,00 €',
    collection: collectionId,
    wave: 3,
    subscription: {
      startDate: '2026-05-05',
      endDate: '2026-06-05',
    },
    specs: [
      { label: 'Millésime', value: milleage },
      { label: 'Métal', value: 'Or 999‰' },
      { label: 'Qualité', value: 'Brillant Universel' },
      { label: 'Poids', value: '16,25 g' },
      { label: 'Diamètre', value: 'Ø 33' },
      { label: 'Exemplaires', value: '2 000' },
    ],
  },
  {
    id: 'gold-5000',
    label: 'Monnaie de <b>5 000 euros Or</b>',
    value: 5000,
    sellPrice: 5250,
    state: 0,
    price: '5000,00 €',
    collection: collectionId,
    wave: 4,
    subscription: {
      startDate: '2026-09-08',
      endDate: '2026-10-09',
    },
    specs: [
      // { label: 'Millésime', value: milleage },
      // { label: 'Métal', value: 'Or 999‰' },
      // { label: 'Qualité', value: 'Brillant Universel' },
      // { label: 'Poids', value: '11,7 g' },
      // { label: 'Diamètre', value: 'Ø 29' },
      // { label: 'Exemplaires', value: '6 000' },
    ],
  },
  {
    id: 'gold-10000',
    label: 'Monnaie de <b>10 000 euros Or</b>',
    value: 10000,
    sellPrice: 10500,
    state: 0,
    price: '10000,00 €',
    collection: collectionId,
    wave: 5,
    launchDate: '2026-11-10',
    specs: [
      // { label: 'Millésime', value: milleage },
      // { label: 'Métal', value: 'Or 999‰' },
      // { label: 'Qualité', value: 'Brillant Universel' },
      // { label: 'Poids', value: '11,7 g' },
      // { label: 'Diamètre', value: 'Ø 29' },
      // { label: 'Exemplaires', value: '6 000' },
    ],
  },
];
